const headers = {
  name: "General Ledger",
   pagination: {
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  },
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by account or description",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort by",
      allowClear: true,
      showSearch: false,
      filterOption: true,
      value: "newest",
      options: [
        { value: "newest", label: "Newest First" },
        { value: "oldest", label: "Oldest First" },
      ],
    },

     {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "button",
      name: "export",
      label: "Export CSV",
      onClick: "exportFunction", 
      icon: "download",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "General Ledger",
        path: "",
      },
      {
        name: "Trial Balance",
        path: "/app/common/reports/trail-balance",
      },
      {
        name: "Balance Sheet",
        path: "/app/common/reports/balance-sheet",
      },
      {
        name: "Profit & Loss",
        path: "/app/common/reports/profit-loss",
      },
       {
        name: "AR Report",
        path: "/app/common/reports/ar-report",
      },
      {
        name: "AP Report",
        path: "/app/common/reports/ap-report",
      },
    ],
    total: [
      { value: 0, label: "Total Entries" },
      { value: 0, label: "Total Debit" },
      { value: 0, label: "Total Credit" },
    ],
  },
};

export default headers;